<template>
    <div class="bg-gray2 my-2 ps-1">
        <ul class="items-list ob1-items-list-inline">
            <li>
                <div class="items-list-item">
                    <div class="item-container item-container-sm">
                        <div class="form-check">
                            <input
                                :id="id + '_yes'"
                                v-model="checked"
                                type="radio"
                                :aria-labelledby="id + '_label_yes'"
                                :name="name"
                                class="form-check-input"
                                :value="true"
                                @change="onChange"
                            >
                            <label aria-hidden="true" class="form-check-label" :for="id + '_yes'" />
                        </div>
                        <label :id="id + 'label_yes'" :for="id + '_yes'" class="item-text">
                            Oui
                        </label>
                    </div>
                </div>
            </li>
            <li>
                <div class="items-list-item">
                    <div class="item-container item-container-sm">
                        <div class="form-check">
                            <input
                                :id="id + '_no'"
                                v-model="checked"
                                type="radio"
                                :aria-labelledby="id + '_label_no'"
                                :name="name"
                                class="form-check-input"
                                :value="false"
                                @change="onChange"
                            >
                            <label aria-hidden="true" class="form-check-label" :for="id + '_no'" />
                        </div>
                        <label :id="id + 'label_no'" :for="id + '_no'" class="item-text">
                            Non
                        </label>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "RecoverySimulatorQuestionRadio",
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            checked: this.value,
        }
    },
    computed: {
    },
    mounted: function () {
    },
    methods: {
        onChange() {
            this.$emit("change", this.checked);
        }
    }
}
</script>

<style lang="scss">

</style>
